import { useState, useEffect } from 'react';
import ProfileMenu from "../profile/ProfileMenu";
import HamburgerMenu from 'react-hamburger-menu';
import useAuth from '../../useAuth';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { claim } = useAuth();
    const bodyClass = 'body--navOpen';

    useEffect(() => {
        const body = document.querySelector('body');

        menuOpen ? addBodyClass(body) : removeBodyClass(body);
    }, [menuOpen]);

    const removeBodyClass = (el) => {
        el.classList.remove(bodyClass);
    };

    const addBodyClass = (el) => {
        el.classList.add(bodyClass);
    };

    return (
        <header className="header">
            <div className="header__hamburger">
                <HamburgerMenu
                    isOpen={menuOpen}
                    menuClicked={() => setMenuOpen(!menuOpen)}
                    width={30}
                    height={20}
                    strokeWidth={2}
                    rotate={0}
                    color='black'
                    borderRadius={0}
                    animationDuration={0.5}
                />
            </div>
            {claim && (
                <span className="header__tenant">{claim.tenant_id} / {claim.email}</span>
            )}
            <ProfileMenu />
        </header>
    )
}

export default Header;